import { createApiActions } from 'iqvia-shared';

import { GET_METADATA_URL, INITIALIZE_URL } from '../constants';
import apiNameEnums from '../../Enums/apiNames';

export const types = {
  JOURNEY_BUILDER_START: 'JOURNEY_BUILDER_START',
  JOURNEY_BUILDER_FINISH: 'JOURNEY_BUILDER_FINISH',
  JOURNEY_BUILDER_SET_TOKEN: 'JOURNEY_BUILDER_SET_TOKEN',
  JOURNEY_BUILDER_SET_INTERACTION: 'JOURNEY_BUILDER_SET_INTERACTION',
  JOURNEY_BUILDER_SET_ACTIVITY: 'JOURNEY_BUILDER_SET_ACTIVITY',
  JOURNEY_BUILDER_SET_STEP: 'JOURNEY_BUILDER_SET_STEP',
};

export const journeyBuilderStart = () => ({
  type: types.JOURNEY_BUILDER_START,
});

export const journeyBuilderFinish = () => ({
  type: types.JOURNEY_BUILDER_FINISH,
});

export const setStep = steps => ({
  type: types.JOURNEY_BUILDER_SET_STEP,
  payload: { steps },
});

export const setToken = tokens => ({
  type: types.JOURNEY_BUILDER_SET_TOKEN,
  payload: { tokens },
});

export const setInteraction = interaction => ({
  type: types.JOURNEY_BUILDER_SET_INTERACTION,
  payload: { interaction },
});

export const setActivity = activity => ({
  type: types.JOURNEY_BUILDER_SET_ACTIVITY,
  payload: { activity },
});

export const initialize = (data, successCallback) =>
  createApiActions(apiNameEnums.POST_INITIALIZE, {
    url: INITIALIZE_URL,
    body: JSON.stringify(data),
    method: 'POST',
    actionTypeOverrides: {
      success: {
        payload: () => successCallback(),
      },
    },
  });

export const fetchJourneyMetadata = (journeyId, buID) =>
  createApiActions(apiNameEnums.GET_JOURNEY_METADATA, {
    url: GET_METADATA_URL.replace('{journeyId}', journeyId).replace('{buID}', buID),
  });



// WEBPACK FOOTER //
// ./src/Root/actions/index.js